// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "07bdcb0e62c1e1823cc7" + ".chunk.js";
};